// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10QTk","content":"styles_content__1-8P7"};